import axios, { AxiosError } from 'axios'

import { useLsGeneralStore } from '@/questionnaire/stores/application'

const baseUrl = `${import.meta.env.VITE_RAILS_API_BASE_URL}/api`
const httpClient = axios.create({ baseURL: baseUrl, withCredentials: true })

httpClient.defaults.headers.common['Content-Type'] = 'application/json'
httpClient.defaults.headers.common['Accept'] = 'application/json'
httpClient.interceptors.response.use(
  response => {
    return response
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      useLsGeneralStore().forceLogout()
    }
    return Promise.reject(error)
  }
)
export default httpClient
